import * as lib from './export';

export * from './export';

export default lib;
